"use client";

import { c as _c } from "react/compiler-runtime";
import { QUERY_PARAM_KEYS } from "@/hooks/query-param/keys";
import { useMarketQueryParam } from "@/hooks/query-param/use-market-query-param";
import { useNumericTraitsQueryParam } from "@/hooks/query-param/use-numeric-traits-query-param";
import { usePriceRangeQueryParamInNativeCurrency } from "@/hooks/query-param/use-price-query-param";
import { useRarityQueryParam } from "@/hooks/query-param/use-rarity-query-param";
import { useSearchQueryQueryParam } from "@/hooks/query-param/use-search-query-query-param";
import { useStatusQueryParam } from "@/hooks/query-param/use-status-query-param";
import { useTraitsQueryParam } from "@/hooks/query-param/use-traits-query-param";
import { useAddress } from "@/hooks/wallet";
export function useCollectionItemsFilters() {
  const $ = _c(17);
  const {
    statuses
  } = useStatusQueryParam();
  const {
    traits
  } = useTraitsQueryParam();
  const {
    numericTraits
  } = useNumericTraitsQueryParam();
  const {
    markets
  } = useMarketQueryParam();
  const address = useAddress();
  const priceRange = usePriceRangeQueryParamInNativeCurrency(QUERY_PARAM_KEYS.price);
  const {
    rarity
  } = useRarityQueryParam();
  const {
    searchQuery
  } = useSearchQueryQueryParam();
  let t0;
  if ($[0] !== statuses) {
    t0 = statuses.includes("listed") || undefined;
    $[0] = statuses;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== statuses) {
    t1 = statuses.includes("hidden") || undefined;
    $[2] = statuses;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== address || $[5] !== statuses) {
    t2 = statuses.includes("ownedByYou") ? address : undefined;
    $[4] = address;
    $[5] = statuses;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== markets || $[8] !== numericTraits || $[9] !== priceRange || $[10] !== rarity || $[11] !== searchQuery || $[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== traits) {
    t3 = {
      traits,
      isListed: t0,
      isHidden: t1,
      markets,
      ownedBy: t2,
      numericTraits,
      priceRange,
      rarityRange: rarity,
      query: searchQuery
    };
    $[7] = markets;
    $[8] = numericTraits;
    $[9] = priceRange;
    $[10] = rarity;
    $[11] = searchQuery;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = traits;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}